import { createSlice } from '@reduxjs/toolkit';
import {
  GetAllUsers,
  GetSearchData,
  GetSingleCustomer,
  GetTotalUserCount,
} from './customer_services_sync';

export const customerSlice = createSlice({
  name: 'customers',
  initialState: {
    customer_loader: false,
    single_customer_loader: true,
    total_customer_loader: false,
    message: '',
    customers: {},
    customersSearchdata: {},
    customerDetails: {},
    totalCustomer: null,
    customerCount: 0,
    customerLimit: 20,
    customerSkip: 0,
  },
  reducers: {
    clearState: (state) => {
      state.customer_loader = false;
      state.message = '';
      state.customers = {};
      state.customersSearchdata = {};
      state.single_customer_loader = true;
      state.total_customer_loader = false;
      state.customerDetails = {};
      state.totalCustomer = null;
      state.customerLimit = 10;
      state.customerSkip = 0;
      state.customerCount = 0;

      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllUsers.pending, (state) => {
        state.customer_loader = true;
      })
      .addCase(GetAllUsers.fulfilled, (state, { payload }) => {
        state.customer_loader = false;
        state.message = payload.message;
        state.customers = payload.data;
        state.customerSkip = payload.data.page;
        state.customerCount = payload.count;
      })
      .addCase(GetAllUsers.rejected, (state, { payload }) => {
        state.customer_loader = false;
        state.message = payload.message;
      });

    builder
      .addCase(GetSingleCustomer.pending, (state) => {
        state.single_customer_loader = true;
      })
      .addCase(GetSingleCustomer.fulfilled, (state, { payload }) => {
        state.single_customer_loader = false;
        state.message = payload.message;
        state.customerDetails = payload.data;
      })
      .addCase(GetSingleCustomer.rejected, (state, { payload }) => {
        state.single_customer_loader = false;
        state.message = payload.message;
      });

    builder
      .addCase(GetSearchData.pending, (state) => {
        state.customer_loader = true;
      })
      .addCase(GetSearchData.fulfilled, (state, { payload }) => {
        state.customer_loader = false;
        state.message = payload.message;
        state.customersSearchdata = payload.data;
      })
      .addCase(GetSearchData.rejected, (state, { payload }) => {
        state.customer_loader = false;
        state.message = payload.message;
      });
  },
});

export const { clearState } = customerSlice.actions;
export const customerSelector = (state) => state.customers;

export default customerSlice.reducer;
